import Header from "@commons/header";
import { LocateFixed } from "lucide-react";
import ZoneForm from "./form";
import ZoneList from "./list";
import Column from "@components/column";

const ZoneSetup = () => {
  return (
    <Column>
      <Header title={"Zone Setup"} icon={LocateFixed} />
      <ZoneForm />
      <ZoneList />
    </Column>
  );
};

export default ZoneSetup;
